import QuestionMultipleChoiceMultipleAnswerComponent from './containers/questionMultipleChoiceMultipleAnswerComponent'

export { default as QuestionMultipleChoiceMultipleAnswerLayout } from './components/questionMultipleChoiceMultipleAnswerLayout' 

export default QuestionMultipleChoiceMultipleAnswerComponent